import axios from "axios";
import { beginGlobalLoading, endGlobalLoading } from "@/utils/globalLoading";
import {
  clearStoredSession,
  hasSessionToken,
  redirectToWebsiteLogin,
} from "@/utils/session";

const authFlowPaths = new Set([
  "/login",
  "/logout",
  "/register/",
  "/register/confirm",
  "/external-confirm-login",
]);

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL + "/website",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    if (!config.skipGlobalLoading) {
      beginGlobalLoading();
      config.__usesGlobalLoading = true;
    }

    const token = hasSessionToken() ? localStorage.getItem("token") : null;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.__hadAuthToken = true;
    }

    return config;
  },
  (error) => {
    if (error?.config?.__usesGlobalLoading) {
      endGlobalLoading();
    }
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    if (response?.config?.__usesGlobalLoading) {
      endGlobalLoading();
    }
    return response;
  },
  (error) => {
    if (error?.config?.__usesGlobalLoading) {
      endGlobalLoading();
    }

    const requestPath = error?.config?.url?.split("?")[0];
    const isAuthenticatedUnauthorized =
      error?.response?.status === 401 &&
      error?.config?.__hadAuthToken &&
      !authFlowPaths.has(requestPath);

    if (isAuthenticatedUnauthorized) {
      clearStoredSession();
      redirectToWebsiteLogin();
    }

    return Promise.reject(error);
  }
);

export default api;
